import React, { useState } from 'react';
import { useProject } from '../contexts/ProjectContext';
import { toggleLotStatusLayer } from '../Map/util';

const ProyectoTab = ({ currentViewData, onOpenPhotos, mapInstance }) => {
  const { project } = useProject();
  const [showLotStatus, setShowLotStatus] = useState(false);
  
  // Verificar si hay imágenes disponibles
  const hasImages = project?.images && project.images.length > 0;

  // Función para alternar la visualización de estados de lotes
  const handleToggleLotStatus = () => {
    if (mapInstance) {
      const isVisible = toggleLotStatusLayer(mapInstance);
      setShowLotStatus(isVisible);
    }
  };
  
  return (
    <div>
      {/* Header con botón de fotos */}


      {/* Información en cards */}
      <div className="space-y-4">
        {/* Card principal */}
        <div className="bg-gradient-to-r from-brand-50 to-brand-100 rounded-lg p-4 border border-brand-100">
          <div className="flex items-start space-x-3">
            <div className="flex-1">
              {/* Título de la propiedad */}
              {project?.property_title && (
                <h3 className="font-professional-semibold text-brand-800 text-sm mb-2">
                  {project.property_title}
                </h3>
              )}
              <p className="text-sm font-professional-light text-gray-500 mt-2">
                {project?.description || 'Sistema de consulta de propiedades inmobiliarias'}
              </p>
            </div>
          </div>
        </div>

        {/* Grid de estadísticas de lotes */}
        <div className="grid grid-cols-2 gap-4">
          {/* Total de Lotes */}
          <div className="bg-gray-50 rounded-lg p-4">
            <div className="flex items-center space-x-2 mb-2">
              <div className="w-8 h-8 bg-brand-100 rounded-lg flex items-center justify-center">
                <svg className="w-4 h-4 text-brand-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                </svg>
              </div>
              <span className="text-sm font-professional-light text-gray-600">Total Lotes</span>
            </div>
            <div className="text-2xl font-professional-semibold text-gray-800">
              {project?.lots_statistics?.total_lots || 0}
            </div>
          </div>

          {/* Lotes Disponibles */}
          <div className="bg-gray-50 rounded-lg p-4">
            <div className="flex items-center space-x-2 mb-2">
              <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center">
                <svg className="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <span className="text-sm font-professional-light text-gray-600">Disponibles</span>
            </div>
            <div className="text-2xl font-professional-semibold text-green-600">
              {project?.lots_statistics?.available_lots || 0}
            </div>
          </div>

        </div>

        {/* Barra de progreso de ventas */}
        {/* {project?.lots_statistics?.total_lots > 0 && (
          <div className="mt-6 bg-white rounded-lg p-4 border border-gray-200">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm font-professional-semibold text-gray-700">Progreso de Ventas</span>
              <span className="text-sm font-professional-light text-gray-500">
                {Math.round(((project.lots_statistics.sold_lots || 0) / project.lots_statistics.total_lots) * 100)}%
              </span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2">
              <div
                className="bg-gradient-to-r from-green-400 to-green-600 h-2 rounded-full transition-all duration-300"
                style={{
                  width: `${((project.lots_statistics.sold_lots || 0) / project.lots_statistics.total_lots) * 100}%`
                }}
              ></div>
            </div>
            <div className="flex justify-between text-xs text-gray-500 mt-1">
              <span>0</span>
              <span>{project.lots_statistics.total_lots} lotes</span>
            </div>
          </div>
        )} */}

        {/* Botones de control */}
        <div className="space-y-3">
          {/* Botón de fotos - solo si hay imágenes */}
          {hasImages && (
            <button
              onClick={onOpenPhotos}
              className="w-full flex items-center justify-center space-x-2 px-3 py-2 bg-brand-50 text-brand-600 rounded-lg hover:bg-brand-100 transition-colors"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              <span className="text-sm font-professional-semibold">Ver fotos del proyecto</span>
            </button>
          )}

          {/* Botón para alternar estados de lotes */}
          <button
            onClick={handleToggleLotStatus}
            className={`w-full flex items-center justify-center space-x-2 px-3 py-2 rounded-lg transition-colors ${
              showLotStatus 
                ? 'bg-purple-100 text-purple-700 hover:bg-purple-200' 
                : 'bg-gray-50 text-gray-600 hover:bg-gray-100'
            }`}
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zM21 5a2 2 0 00-2-2h-4a2 2 0 00-2 2v12a4 4 0 004 4h4a2 2 0 002-2V5z" />
            </svg>
            <span className="text-sm font-professional-semibold">
              {showLotStatus ? 'Ocultar estados' : 'Mostrar estados'}
            </span>
          </button>

          {/* Leyenda de estados - solo cuando está activa */}
          {showLotStatus && (
            <div className="bg-white rounded-lg p-3 border border-gray-200">
              <h4 className="text-xs font-professional-semibold text-gray-700 mb-2">Estados de Lotes</h4>
              <div className="space-y-1">
                <div className="flex items-center space-x-2">
                  <div className="w-3 h-3 bg-green-500 rounded-sm"></div>
                  <span className="text-xs text-gray-600">Disponibles</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-3 h-3 bg-yellow-500 rounded-sm"></div>
                  <span className="text-xs text-gray-600">Reservados</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-3 h-3 bg-blue-500 rounded-sm"></div>
                  <span className="text-xs text-gray-600">En Venta</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-3 h-3 bg-red-500 rounded-sm"></div>
                  <span className="text-xs text-gray-600">Vendidos</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-3 h-3 bg-gray-500 rounded-sm"></div>
                  <span className="text-xs text-gray-600">No Disponibles</span>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="w-3 h-3 bg-purple-500 rounded-sm"></div>
                  <span className="text-xs text-gray-600">Devolución</span>
                </div>
              </div>
            </div>
          )}
        </div>

      </div>
    </div>
  );
};

export default ProyectoTab;